const MissionsList = () =>
  import(/* webpackChunkName: "MissionsList" */ "@/components/ssp/missions/MissionsList.vue");

export default [
  {
    path: "",
    name: "missionsList",
    component: MissionsList,
  },
];
